import { cx } from "../../lib/cx";

interface ProgressProps {
  value: number;
  max?: number;
  size?: "sm" | "lg";
  className?: string;
}

export function Progress({ value, max = 100, size = "sm", className }: ProgressProps) {
  const pct = max <= 0 ? 0 : Math.min(100, Math.max(0, (value / max) * 100));
  return (
    <div
      className={cx("progress-track", size === "lg" && "progress-track--lg", className)}
      role="progressbar"
      aria-valuenow={Math.round(pct)}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <div className="progress-track__fill" style={{ width: `${pct}%` }} />
    </div>
  );
}
